/**
 * ERP Financial API client for multi-hierarchy CoA.
 * @see https://erp.fms.ogintegration.us/docs/api/group-hierarchy#get-direct-child-groups-from-the-parent-group
 */

import { erpRequest } from './erpRequest';

export interface ErpChildGroup {
  id: string;
  name: string;
}

export interface ErpChildGroupsResponse {
  data: ErpChildGroup[];
}

export interface ErpGetChildGroupsParams {
  groupId: string;
}

export const getErpChildGroups = async (
  { groupId }: ErpGetChildGroupsParams,
  clientOptions: RequestInit = {},
  hostUrl?: string
): Promise<ErpChildGroupsResponse> => {
  let req = erpRequest(`/groups/${encodeURIComponent(groupId)}/child-groups`, clientOptions, hostUrl);

  return (await req.get().json()) as ErpChildGroupsResponse;
};
